// extracted by mini-css-extract-plugin
export default {"container":"Price_container__5cyZX","button":"Price_button__o2ypM","contacts":"Price_contacts__tBJFe","address":"Price_address__5ijfi"};